export default __webpack_public_path__ + "static/media/Previews_29.d76f6c8e.jpg";